import FuseUtils from '@fuse/utils/FuseUtils';
import axios from 'axios';
//import jwtDecode from 'jwt-decode';
/* eslint-disable camelcase */
import { socket } from 'context/socket';
import * as HELPER from 'context/helper';

//import TokenService from "./token.service";

//import { createStore } from 'redux';
//import {toasterActions} from 'app/auth/store/actions';
//import reducer from 'app/auth/store/reducers';

//const store = createStore(reducer);

/*const getDeviceId = async () => {
	let _browserToken = window.localStorage.getItem("s_b_w_token")
	if(!_browserToken) {
		  _browserToken = await Date.now().toString();
	  await window.localStorage.setItem("s_b_w_token", _browserToken);
		  return _browserToken
	} else {
		  return _browserToken
	  }
  
}*/

class JwtService extends FuseUtils.EventEmitter {
	init() {
		this.setInterceptors();
		this.handleAuthentication();
		localStorage.setItem('iconNotif', '/assets/icons/icon-57x57.png');
		//console.log("init jwt")
		//const oldKey = ''
		setInterval(function() {
			//alert("refresh token!")
			return new Promise((resolve, reject) => {
				let current_user = JSON.parse(localStorage.getItem('current_user'));
				let token = current_user && current_user['authToken'];
				let data = {}
				const headersToken = {
					'Content-Type': 'application/json',
					headers: {"Authorization": `Token ${token}`}
				};
				token &&
				 axios
					.post(process.env.REACT_APP_SERVER + '/api/auth/token/refresh', data, headersToken)
					.then(response => {
						if (response.data.isError === false) {
							console.log("token refresh success >>>>>>>>>>> ", response, response.data.authToken)
							//this.setSession(response.data.authToken);
							localStorage.setItem('jwt_access_token', response.data.authToken);
							var data = window.localStorage.getItem('current_user');
							axios.patch(process.env.REACT_APP_SERVER + '/api/auth/token/refresh', {'tokenKey' : response.data.oldKey}, headersToken)
							if (data !== null) {
								let current_user= JSON.parse(data);
								current_user['authToken'] = response.data.authToken;
								window.localStorage.setItem('current_user', JSON.stringify(current_user));
							} 
							resolve(response.data);
						} else {
							reject(response.data.error);
						}
					})
					.catch(error => {
						console.log('refreshAccessToken error', error);
						//reject(error.response);
					})
			});
		}, 10800000)
	}



	setInterceptors = () => {
		axios.interceptors.response.use(
			response => {
				return response;
			},
			err => {
				return new Promise((resolve, reject) => {
					if (err.response && err.response.status === 401 && err.config && !err.config.__isRetryRequest) {
						// if you ever get an unauthorized response, logout the user
						console.log(">>>>> check your network. probably have an issue when calling an API")
						//this.emit('onAutoLogout', 'Invalid access_token');
						localStorage.removeItem('jwt_access_token');
						localStorage.removeItem('current_user');
						this.setSession(null);
						window.location.href = '/login';

					}
					throw err;
				});
			}
		);
	};

	handleAuthentication = () => {
		//console.log("handleAuthentication")
		const access_token = this.getAccessToken();

		if (!access_token) {
			//console.log("y'a plus d'access token")
			this.emit('onNoAccessToken');

			return;
		}

		if (this.isAuthTokenValid(access_token)) {
			this.setSession(access_token);
			this.emit('onAutoLogin', true);
			//console.log(">>>>>>>>>>>>>>> TEST 1")
		} else {
			this.setSession(null);
			this.emit('onAutoLogout', 'access_token expired');
			//console.log(">>>>>>>>>>>>>>> TEST 2")
		}
	};

	createUser = data => {
		let send_data = {
			"name": data.name,
			"user_email": data.email,
			"affiliation": data.affiliation,
			"position": data.position,
			"group_type": data.groupType,
			"user_password": data.password,
			"user_cnf_password": data.password_cnf
		}
		return new Promise((resolve, reject) => {
			axios.post(process.env.REACT_APP_SERVER + '/api/auth/registration', send_data).then(response => {
				if (response.data) {
					//this.setSession(response.data.access_token);
					resolve(response.data);
				} else {
					reject(response.data.error);
				}
			});
		});
	};

	signInWithEmailAndPassword = (data) => {
		return new Promise((resolve, reject) => {
			axios
				.post(process.env.REACT_APP_SERVER + '/api/auth/login', data)
				.then(response => {
					if (response.data) {
						this.setSession(response.data.userDetails.authToken);
						//set local storage and authToken
						localStorage.setItem('current_user', JSON.stringify(response.data.userDetails));
						socket.emit("user_is_logged_in", { userId: response.data.userDetails.id, authToken: HELPER.getAuthToken() })
						resolve(response.data);
						localStorage.setItem('persistCompanyID', response.data.userDetails.company.companyID);
						localStorage.setItem('persistDomain',  response.data.userDetails.company.domain);
						localStorage.setItem('persistCompanyName', response.data.userDetails.company.name);
						/*axios.get(process.env.REACT_APP_SERVER_SOCKET + 'callinginfo/call-progress-status').then(res => {
							console.log("call-progress-status", res)
						})*/
					} else {
						reject(response.data.error);
					}
				})
				.catch(error => {
					//console.log('signInWithEmailAndPassword error', error.response);
					reject(error.response);
				})
		});
	};

	signInWithToken = () => {
		//console.log(">>>>>> try to signInWithToken")
		return new Promise((resolve, reject) => {
			this.setSession(localStorage.getItem('jwt_access_token'));
			resolve(JSON.parse(localStorage.getItem('current_user')));
		});
	};

	updateUserData = user => {
		return axios.post('/api/auth/user/update', {
			user
		});
	};

	setSession = access_token => {
		//console.log('access',access_token)
		if (access_token) {
			localStorage.setItem('jwt_access_token', access_token);
			axios.defaults.headers.common.Authorization = `Bearer ${access_token}`;
		} else {
			localStorage.removeItem('jwt_access_token');
			delete axios.defaults.headers.common.Authorization;
		}
	};

	logout = () => {
		//const access_token = this.getAccessToken();
		//console.log("click on logout ", access_token);
		localStorage.removeItem('jwt_access_token');
		//::Reset Admin Local Storage
		localStorage.removeItem('persistDomain');
		localStorage.removeItem('persistCompanyID');
		localStorage.removeItem('persistProjectSelected');
		localStorage.removeItem('persistMembers');
		localStorage.removeItem('persistCompanyName');
		localStorage.removeItem('persistCompanyData');
		localStorage.removeItem('persistProjectUUID');
		localStorage.removeItem('mixCalendar_staffUsersData');
		localStorage.removeItem('mixCalendar_staffUsersChecked');
		localStorage.removeItem('mixCalendar_groupTypeCheckList');
		localStorage.removeItem('mixCalendar_groupTypeChecked');
		localStorage.removeItem('mixCalendar_lastProject');
		localStorage.removeItem('mixCalendar_showHideSiteCalendar');
		localStorage.removeItem('mixCalendar_usersColor');
		//socket.emit("user_is_logged_out", {userId: response.data.userDetails.id})
		this.setSession(null);
	};

	isAuthTokenValid = access_token => {
		if (!access_token) {
			return false;
		}
		//const storedToken = localStorage.getItem("jwt_access_token");
		//console.log("quel est l'access token : ", storedToken)
		/*const decoded = jwtDecode(storedToken);
		console.log("decoded ? : ", decoded)
		const currentTime = Date.now() / 1000;
		if (decoded.exp < currentTime) {
			console.warn('access token expired');
			return false;
		}*/

		return true;
	};

	getAccessToken = () => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user && current_user['authToken'];
		return token
	};
}

const instance = new JwtService();

export default instance;
